import { SVGProps } from 'react';

const ClockAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 6v6l4 2m4-2v5m0 4h.01m1.24-12.8A10 10 0 1 0 16 21.16"
    />
  </svg>
);
export default ClockAlert;
